import React, { useEffect, useState } from "react";
import { SelectBox } from "devextreme-react";
import DataGrid, { Column, Editing } from "devextreme-react/data-grid";
import { Toster } from "../../components/Toster/Toster";
import httpService from "../../services/http-service";
import { getAuthToken } from "../../services/auth-service";

const ActivityTypeGroupsPopup = ({
  showActivityTypeGroupsPopup,
  setShowActivityTypeGroupsPopup,
  toastConfig,
  setToastConfig,
}) => {
  const [activityTypes, setActivityTypes] = useState([]);
  const [selectedActivityType, setSelectedActivityType] = useState(null);
  const [userGroups, setUserGroups] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [originalData, setOriginalData] = useState([]);
  const [showOnlySelected, setShowOnlySelected] = useState(false);
  let domainName = (url) => url.match(/(?:http(?:s)?:\/\/)?(?:w{3}\.)?([^.]+)/i)[1];
  let pathURL = domainName(window.location.href);

  const token = getAuthToken();

  useEffect(() => {
    if (showActivityTypeGroupsPopup) {
      fetchActivityTypes();
    }
  }, [showActivityTypeGroupsPopup]);

  useEffect(() => {
    if (selectedActivityType) fetchGroupsByType(selectedActivityType);
  }, [selectedActivityType]);

  const fetchActivityTypes = () => {
    httpService
      .get("/api/activity/get-activity-type-list", {
        headers: {
          Authorization: `Bearer ${token}`,
          Domain: pathURL,
        },
      })
      .then((res) => {
        // console.log(res.data);
        setActivityTypes(res.data?.data || []);
        if (res.data?.data.length) setSelectedActivityType(res.data?.data[0].gActivityTypeId);
      })
      .catch(() => {
        setToastConfig({
          isVisible: true,
          message: "Error fetching activity types",
          type: "error",
        });
        setTimeout(() => setToastConfig({ isVisible: false, message: "", type: "" }), 2000);
      });
  };

  const fetchGroupsByType = (activityTypeId) => {
    httpService
      .get(`/api/activity/get-groups-by-type?GActivityTypeId=${activityTypeId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Domain: pathURL,
        },
      })
      .then((res) => {
        console.log("groupsbytype", res.data);
        setUserGroups(res.data.data || []);
        setOriginalData(JSON.parse(JSON.stringify(res.data.data)));
      })
      .catch(() => {
        setToastConfig({
          isVisible: true,
          message: "Error fetching user groups",
          type: "error",
        });
        setTimeout(() => setToastConfig({ isVisible: false, message: "", type: "" }), 2000);
      });
  };

  const handleSave = () => {
    const updatedGroups = userGroups.map((item) => ({
      gActivityTypeID: selectedActivityType,
      gUserGroupID: item.gUserGroupID,
      sUserGroupName: item.sUserGroupName,
      bSelected: item.bSelected,
    }));

    httpService
      .post("/api/Activity/save-groups", updatedGroups, {
        headers: {
          Authorization: `Bearer ${token}`,
          Domain: pathURL,
          // "Content-Type": "application/json",
        },
      })
      .then(() => {
        const selected = updatedGroups.filter((g) => g.bSelected);
        setUserGroups(selected);
        setShowOnlySelected(true);
        setEditMode(false);
        setToastConfig({
          isVisible: true,
          message: "Activity Groups successfully saved!",
          type: "success",
        });
        setTimeout(() => setToastConfig({ isVisible: false, message: "", type: "" }), 2000);
      })
      .catch(() => {
        setToastConfig({
          isVisible: true,
          message: "Error saving changes",
          type: "error",
        });
        setTimeout(() => setToastConfig({ isVisible: false, message: "", type: "" }), 2000);
      });
  };

  return (
    <div className="activity-type-popup-container" style={{ padding: "10px" }}>
      <div className="popup_header">
        <div className="popup_header_title">
          <div className="popup_header_title_data">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path
                d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1.003 1.003 0 0 0 0-1.41l-2.34-2.34a1.003 1.003 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                fill="white"
              />
            </svg>
            <p>Activity Type</p>
          </div>
          <p className="popup_header_title_para">AC.2</p>
        </div>
        <svg
          onClick={() => setShowActivityTypeGroupsPopup(false)}
          style={{ cursor: "pointer" }}
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
        >
          <path
            d="M9.72406 0.282539C9.43156 -0.00996077 8.95906 -0.00996077 8.66656 0.282539L4.99906 3.94254L1.33156 0.275039C1.03906 -0.0174609 0.566563 -0.0174609 0.274063 0.275039C-0.0184375 0.567539 -0.0184375 1.04004 0.274063 1.33254L3.94156 5.00004L0.274063 8.66754C-0.0184375 8.96004 -0.0184375 9.43254 0.274063 9.72504C0.566563 10.0175 1.03906 10.0175 1.33156 9.72504L4.99906 6.05754L8.66656 9.72504C8.95906 10.0175 9.43156 10.0175 9.72406 9.72504C10.0166 9.43254 10.0166 8.96004 9.72406 8.66754L6.05656 5.00004L9.72406 1.33254C10.0091 1.04754 10.0091 0.567539 9.72406 0.282539Z"
            fill="white"
          />
        </svg>
      </div>
      <div className="form-group" style={{ width: "300px", marginBottom: "16px" }}>
        <label>Note Type</label>
        <SelectBox
          dataSource={activityTypes}
          displayExpr="sName"
          valueExpr="gActivityTypeId"
          value={selectedActivityType}
          onValueChanged={(e) => setSelectedActivityType(e.value)}
          style={{ width: "100%" }}
          disabled={editMode}
        />
      </div>
      <div style={{ width: "350px", overflowY: "auto", marginBottom: "16px" }}>
        <DataGrid dataSource={userGroups} keyExpr="gUserGroupID" showBorders columnAutoWidth height="auto">
          <Editing mode="cell" allowUpdating={editMode} />
          <Column dataField="sUserGroupName" caption="User Group" allowEditing={false} />
          <Column dataField="bSelected" caption="Select" dataType="boolean" allowEditing={editMode} />
        </DataGrid>
      </div>
      <div className="popup_buttons right" style={{ marginTop: "32px" }}>
        <button
          className="btn cancel_btn"
          onClick={() => {
            if (editMode) {
              setUserGroups(JSON.parse(JSON.stringify(originalData)));
              setEditMode(false);
            } else {
              setShowActivityTypeGroupsPopup(false);
            }
          }}
        >
          Cancel
        </button>
        <button
          className="btn primary_btn"
          onClick={() => {
            if (editMode) {
              handleSave();
            } else {
              fetchGroupsByType(selectedActivityType);
              setEditMode(true);
               setShowOnlySelected(false);
            }
          }}
        >
          {editMode ? "Save" : "Edit"}
          {!editMode && (
            <svg width="14" height="14" viewBox="0 0 24 24" fill="white" style={{ marginRight: "6px" }}>
              <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1.003 1.003 0 0 0 0-1.41l-2.34-2.34a1.003 1.003 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
            </svg>
          )}
        </button>
      </div>
    </div>
  );
};

export default ActivityTypeGroupsPopup;
